import Bowser from "bowser";

function checkWebGL() {
  const canvas = document.createElement("canvas");
  // Get WebGLRenderingContext from canvas element.
  const gl =
    canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
  // Report the result.
  if (gl && gl instanceof WebGLRenderingContext) {
    return true;
  } else {
    return false;
  }
}

export function checkCompatibility() {
  const browser = Bowser.getParser(window.navigator.userAgent);

  const isValidBrowser = browser.satisfies({
    chrome: ">72",
    chromium: ">73",
    firefox: ">65",
    safari: ">=12.1",
    edge: ">=17"
  });

  const isOutdated = browser.satisfies({
    chrome: "<=72",
    chromium: "<=73",
    firefox: "<=65",
    safari: "<12.1",
    edge: "<17"
  });

  const features = {
    features: {
      blendedView: {
        name: "Blended view mode",
        //Does not work for edgehtml
        enabled: isValidBrowser && !browser.satisfies({ edge: "<19" })
      }
    },

    webgl: checkWebGL(),
    compatible: isValidBrowser,
    outdated: isOutdated,
    browser: browser.getBrowser()
  };

  return features;
}
